/**
 * formatters.js
 *
 * Fonctions utilitaires de formatage pour dates, prix, etc.
 */

/**
 * Formate une date en format lisible français
 * @param {string|Date} date - La date à formater
 * @returns {string} Date formatée
 */
export const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

/**
 * Formate une date avec heure
 * @param {string|Date} date - La date à formater
 * @returns {string} Date et heure formatées
 */
export const formatDateTime = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

/**
 * Formate un prix avec devise
 * @param {number} price - Le prix
 * @param {string} devise - La devise (défaut: $)
 * @returns {string} Prix formaté
 */
export const formatPrice = (price, devise = "$") => {
    if (!price && price !== 0) return "N/A";
    return `${parseFloat(price).toFixed(2)} ${devise}`;
};

/**
 * Formate un nombre avec séparateurs
 * @param {number} num - Le nombre
 * @returns {string} Nombre formaté
 */
export const formatNumber = (num) => {
    if (!num && num !== 0) return "N/A";
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

/**
 * Formate le statut d'une offre
 * @param {string} status - Statut (IN_SELL, SOLD)
 * @returns {string} Statut formaté
 */
export const formatStatus = (status) => {
    const statuses = {
        IN_SELL: "En vente",
        SOLD: "Vendu",
        REMOVED: "Retiré",
    };
    return statuses[status] || status;
};

/**
 * Retourne la couleur du statut
 * @param {string} status - Statut
 * @returns {string} Couleur Ant Design
 */
export const getStatusColor = (status) => {
    const colors = {
        IN_SELL: "green",
        SOLD: "red",
        REMOVED: "orange",
    };
    return colors[status] || "default";
};